module.exports = __webpack_public_path__ + "img/go-right.c47daef1.svg";